"use strict";

const IncidentInvestigationSummary = function () {
  var getSummaryHtml = function (data) {
    const incidentTypeOptions = IncidentInvestigationConstants.getIncidentTypeOptions();
    return nunjucks.render("modals/incidentInvestigation/templates/summary.njk", {
      displayIncidentType: incidentTypeOptions?.getObjectWith("value", data.incidentType)?.name,
      responsiblePartyIdentified: data.responsiblePartyIdentified,
    });
  };

  return {
    getSummaryHtml,
  };
};

module.exports = IncidentInvestigationSummary();

const IncidentInvestigationConstants = require("./incidentInvestigationConstants");
